import { BasicDetails, Template, User, WorkflowItem } from './interfaces';
import { HeaderResponse, HeaderOptions } from '../base/interfaces/headerInterface';

export const SET_BASIC_DETAILS = 'SET_BASIC_DETAILS';
export const UPDATE_CURRENT_WORKFLOW_ITEM = 'UPDATE_CURRENT_WORKFLOW_ITEM';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const UPDATE_CANDIDATE = 'UPDATE_CANDIDATE';
export const UPDATE_HEADER_DETAILS = 'UPDATE_HEADER_DETAILS';
export const UPDATE_HEADER_OPTIONS = 'UPDATE_HEADER_OPTIONS';
export const UPDATE_USER_INACTIVITY = 'UPDATE_USER_INACTIVITY';
export const UPDATE_TIMELINE_SPINNER_STATE = 'UPDATE_TIMELINE_SPINNER_STATE';
export const UPDATE_TIMELINE_STYLE = 'UPDATE_TIMELINE_STYLE';
interface BasicDetailsAction {
  type: typeof SET_BASIC_DETAILS;
  payload: BasicDetails;
}

interface UpdateCurrentWorkflowItemAction {
  type: typeof UPDATE_CURRENT_WORKFLOW_ITEM;
  payload: WorkflowItem;
}

interface UpdateTemplateAction {
  type: typeof UPDATE_TEMPLATE;
  payload: Template;
}

interface UpdateCandidateAction {
  type: typeof UPDATE_CANDIDATE;
  payload: User;
}

interface UpdateHeaderDetailsAction {
  type: typeof UPDATE_HEADER_DETAILS;
  payload: HeaderResponse;
}

interface UpdateHeaderOptionsAction {
  type: typeof UPDATE_HEADER_OPTIONS;
  payload: HeaderOptions;
}

interface UpdateUserInactivityAction {
  type: typeof UPDATE_USER_INACTIVITY;
  payload: boolean;
}

interface UpdateTimeLineSpinner {
  type: typeof UPDATE_TIMELINE_SPINNER_STATE;
  payload: boolean;
}

interface UpdateTimeLineStyle {
  type: typeof UPDATE_TIMELINE_STYLE;
  payload: boolean;
}

export type StoreAction =
  | BasicDetailsAction
  | UpdateCurrentWorkflowItemAction
  | UpdateTemplateAction
  | UpdateCandidateAction
  | UpdateHeaderDetailsAction
  | UpdateHeaderOptionsAction
  | UpdateUserInactivityAction
  | UpdateTimeLineSpinner
  | UpdateTimeLineStyle;
